/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	export enum Mode {
		Interactive = 'mode-interactive',
		Recording = 'mode-recording',
	}
}
